import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./app/routes";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "react-hot-toast";

const App = () => {
  return (
    <BrowserRouter>
       <Toaster
        position="top-right"
        toastOptions={{
          duration: 3008,
          style: {
            fontSize: "14px",
          },
        }}
      />
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
